import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../api/api-context';
import { z } from 'zod';
// plaid link token response schema
export const plaidLinkTokenResponseSchema = z.object({
    linkToken: z.string(),
});
/**
 * Hook for creating a Plaid link token
 */
export const useCreateLinkTokenApi = (mutationConfig) => {
    const api = useApi();
    const { onSuccess, onError, ...restConfig } = mutationConfig || {};
    const plaidLinkTokenApi = async () => {
        const response = await api.post('/plaid/link-token');
        return plaidLinkTokenResponseSchema.parse(response.data);
    };
    return useMutation({
        onSuccess: (...args) => {
            onSuccess?.(...args);
        },
        onError,
        ...restConfig,
        mutationFn: plaidLinkTokenApi,
    });
};
